import {
  LinkShorteningOffIcon,
  LinkShorteningOnIcon,
} from '@buffer-mono/popcorn'

export const LinkShortenerIcon = (props: {
  isDisabled: boolean
}): JSX.Element => {
  return (
    <>
      {props.isDisabled && <LinkShorteningOffIcon />}

      {!props.isDisabled && <LinkShorteningOnIcon />}
    </>
  )
}
